<canvas tabindex="0" width="400" height="200" #signatureCanvas class="signature-pad-canvas"></canvas>
<button class="generic-button btn-clear" (click)="clear()" title="effacer la signature"><i class="material-icons">clear</i><span> Effacer</span></button>
